//
//
//
//
//
//
//

import uiOpen from '@/component/uiOpen/uiOpen'
import uiBottom from '@/component/uiBottom'
import { shareFun } from '@/util/const'

export default {
  components: {
    uiBottom,
    uiOpen
  },
  create () {
    shareFun({
      title: '分享demo',
      content: '组件open或则js直接open',
      url: window.location.href
    })
  },
  methods: {
    openApp () {
      this.$openApp({ url: location.href })
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/demo/shareDemo.vue